module.exports = __webpack_public_path__ + "media/lookbook_1.cebbe44b.webm";